import React from "react";
import InstantCriminalReport from "./InstantCriminalReport";
import PersonMoreDetails from "./PersonMoreDetails";
import BusinessReport from "./BusinessReport";
import ReportRoot from "./ReportRoot";
import CriminalMultiSectionNimbusReport from "./Criminal/CriminalMultiSectionNimbusReport";
import VehicleDppaReport from "./Vehicles/VehicleDppaReport";
import BusinessBljReport from "./Business/BusinessBljReport";
import PropertyReport from "./Property/PropertyReport";
import NeighborsReport from "./NeighborsReport";
import CommonResidencyReport from "./CommonResidencyReport";
import BusinessUccNimbusReport from "./BusinessUccNimbusReport";
import PersonBljNimbusReport from "./Civil/PersonBljNimbusReport";
import RelativesNimbusReport from "./RelativesNimbusReport";
import PiplReport from "./PiplReport";

const getReportComponentByName = (
  root,
  reportData,
  handleNewSearchClick,
  handleHomeValueClick,
  handleMapClick,
  handleHomeIncomeClick,
  additionalData,
  userInterruption,
  showReport,
  printContent,
  history
) => {
  if (!additionalData) return <span />;
  if (additionalData.menuId === 411 || additionalData.menuId === 420) {
    return (
      <InstantCriminalReport
        reportData={reportData}
        handleNewSearchClick={handleNewSearchClick}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        additionalData={additionalData}
        userInterruption={userInterruption}
        showReport={showReport}
        printContent={printContent}
      />
    );
  }
  if (root === "Person/MoreDetails") {
    return (
      <PersonMoreDetails
        reportData={reportData}
        handleNewSearchClick={handleNewSearchClick}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        additionalData={additionalData}
        userInterruption={userInterruption}
        showReport={showReport}
        printContent={printContent}
        isPlatinumReport={additionalData.menuId === 117}
        history={history}
      />
    );
  }
  if (
    additionalData.menuId === 114 ||
    additionalData.menuId === 118 ||
    additionalData.menuId === 211 ||
    additionalData.menuId === 117 ||
    additionalData.menuId === 113 ||
    additionalData.menuId === 111
  ) {
    return (
      <ReportRoot
        reportData={reportData}
        handleNewSearchClick={handleNewSearchClick}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        additionalData={additionalData}
        userInterruption={userInterruption}
        showReport={showReport}
        printContent={printContent}
        isGoldReport={additionalData.optReportType === "compgold" || additionalData.optReportType === "comp"}
        isPlatinumReport={additionalData.optReportType !== "comp"}
        history={history}
      />
    );
  }

  if (additionalData.menuId === 152) {
    return (
      <ReportRoot
        reportData={reportData}
        handleNewSearchClick={handleNewSearchClick}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        additionalData={additionalData}
        userInterruption={userInterruption}
        showReport={showReport}
        printContent={printContent}
        isPlatinumReport={additionalData.optReportType !== "comp"}
        isSilverReport
      />
    );
  }

  if (
    additionalData.menuId === 153 ||
    additionalData.menuId === 112 ||
    additionalData.menuId === 116
  ) {
    return (
      <ReportRoot
        reportData={reportData}
        handleNewSearchClick={handleNewSearchClick}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        additionalData={additionalData}
        userInterruption={userInterruption}
        showReport={showReport}
        printContent={printContent}
        isPlatinumReport={
          !(
            additionalData.optReportType === "comp" ||
            additionalData.optReportType === "compgold"
          )
        }
        isGoldReport={
          additionalData.optReportType === "comp" ||
          additionalData.optReportType === "compgold"
        }
        history={history}
      />
    );
  }

  if (additionalData.menuId === 121 || additionalData.menuId === 122
    || additionalData.menuId === 711 || additionalData.menuId === 811
  ) {
    return (
      <PiplReport
        reportData={reportData}
        handleNewSearchClick={handleNewSearchClick}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        additionalData={additionalData}
        userInterruption={userInterruption}
        showReport={showReport}
        printContent={printContent}
      />
    );
  }
  if (additionalData.menuId === 144) {
    return (
      <RelativesNimbusReport
        reportData={reportData}
        handleNewSearchClick={handleNewSearchClick}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        additionalData={additionalData}
        userInterruption={userInterruption}
        showReport={showReport}
        printContent={printContent}
      />
    );
  }
  if (
    additionalData.menuId === 611 ||
    additionalData.menuId === 221 ||
    additionalData.menuId === 222
  ) {
    return (
      <BusinessReport
        reportData={reportData}
        handleNewSearchClick={handleNewSearchClick}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        additionalData={additionalData}
        userInterruption={userInterruption}
        showReport={showReport}
        printContent={printContent}
      />
    );
  }
  if (
    additionalData.menuId === 412 ||
    additionalData.menuId === 414 ||
    additionalData.menuId === 413 ||
    additionalData.menuId === 415
  ) {
    return (
      <CriminalMultiSectionNimbusReport
        reportData={reportData}
        handleNewSearchClick={handleNewSearchClick}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        additionalData={additionalData}
        userInterruption={userInterruption}
        showReport={showReport}
        printContent={printContent}
      />
    );
  }
  if (additionalData.menuId === 421) {
    return (
      <PersonBljNimbusReport
        reportData={reportData}
        handleNewSearchClick={handleNewSearchClick}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        additionalData={additionalData}
        userInterruption={userInterruption}
        showReport={showReport}
        printContent={printContent}
      />
    );
  }
  if (additionalData.menuId === 311) {
    return (
      <VehicleDppaReport
        reportData={reportData}
        handleNewSearchClick={handleNewSearchClick}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        additionalData={additionalData}
        userInterruption={userInterruption}
        showReport={showReport}
        printContent={printContent}
      />
    );
  }
  if (
    additionalData.menuId === 612 ||
    additionalData.menuId === 422 ||
    additionalData.menuId === 621
  ) {
    return (
      <BusinessBljReport
        reportData={reportData}
        handleNewSearchClick={handleNewSearchClick}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        additionalData={additionalData}
        userInterruption={userInterruption}
        showReport={showReport}
        printContent={printContent}
      />
    );
  }
  if (
    additionalData.menuId === 615
  ) {
    return (
      <BusinessUccNimbusReport
        reportData={reportData}
        handleNewSearchClick={handleNewSearchClick}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        additionalData={additionalData}
        userInterruption={userInterruption}
        showReport={showReport}
        printContent={printContent}
      />
    );
  }

  if (additionalData.menuId === 321) {
    return (
      <PropertyReport
        reportData={reportData}
        handleNewSearchClick={handleNewSearchClick}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        additionalData={additionalData}
        userInterruption={userInterruption}
        showReport={showReport}
        printContent={printContent}
      />
    );
  }

  if (additionalData.menuId === 142) {
    return (
      <NeighborsReport
        reportData={reportData}
        handleNewSearchClick={handleNewSearchClick}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        additionalData={additionalData}
        userInterruption={userInterruption}
        showReport={showReport}
        printContent={printContent}
      />
    );
  }

  if (additionalData.menuId === 143) {
    return (
      <CommonResidencyReport
        reportData={reportData}
        handleNewSearchClick={handleNewSearchClick}
        handleHomeValueClick={handleHomeValueClick}
        handleMapClick={handleMapClick}
        handleHomeIncomeClick={handleHomeIncomeClick}
        additionalData={additionalData}
        userInterruption={userInterruption}
        showReport={showReport}
        printContent={printContent}
      />
    );
  }

  return <span />;
};

export default getReportComponentByName;



// WEBPACK FOOTER //
// ./src/components/reports/SearchReportComponentFactory.js